<template>
    <div v-if="!stepStore.loading">
        <OrderList v-model="stepLinks" listStyle="height:'auto'" :data-key="stepLinks.id">
            <template #header>
                <div class="flex justify-content-between">
                    <span>List of Links</span>
                    <Button icon="pi pi-plus" class="p-button-rounded mr-2 mb-2" v-tooltip="'Add a new link'" @click="openLinkForm('add')" />
                </div>
            </template>
            <template #item="slotProps">
                <div class="flex justify-content-between">
                    <span class="font-bold">{{ slotProps.item.step_to?.label ?? stepStore.getStepLabelById(slotProps.item.step_to) }}</span>
                    <div class="flex justify-content-between">
                        <Button icon="pi pi-eye" class="p-button-sm p-button-rounded mr-1 mb-2" v-tooltip="'View Link Details'" @click="viewLinkDetails(slotProps.item)" />
                        <Button icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-2" v-tooltip="'Edit Link Details'" @click="openLinkForm('edit', slotProps.item)" />
                        <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-danger mr-1 mb-2" v-tooltip="'Edit Link Details'" @click="confirmDelete(slotProps.item)" />
                    </div>
                </div>
            </template>
        </OrderList>
        <!-- Link Edit form -->
        <link-form v-if="linkFormDialog" :mode="mode" @hide-dialog="linkFormDialog = false" />

        <!-- Link Details Dialog -->
        <LinkDetails v-if="detailsDialog" :link="details" @hide-dialog="detailsDialog = false" />
    </div>
</template>

<script setup>
import { ref, defineProps, inject, computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import LinkDetails from './LinkDetails.vue';
import LinkForm from './LinkForm.vue';

const toast = useToast();
const confirm = useConfirm();
const stepStore = inject('stepStore');
const linkStore = inject('linkStore');

const props = defineProps({
    stepId: {
        type: Number,
        required: true,
    },
});

const stepLinks = computed(() => {
    return linkStore.getStepLinks(props.stepId);
});

const detailsDialog = ref(false);
const details = ref([]);

const linkFormDialog = ref(false);
const mode = ref(null);

const openLinkForm = (optMode, linkData = null) => {
    mode.value = optMode;
    linkFormDialog.value = true;
    if (mode.value === 'edit') {
        linkStore.editLink(linkData);
    }
};

const viewLinkDetails = (link) => {
    detailsDialog.value = true;
    details.value = link;
};

const confirmDelete = (link) => {
    confirm.require({
        header: 'Delete Confirmation',
        message: 'Are you sure you want to delete link ' + link?.id + '?',
        icon: 'pi pi-info-circle',
        accept: async () => {
            await linkStore.deleteLink(link?.id);
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
};
</script>

<style lang="scss">
.p-orderlist-controls {
    display: none;
}
</style>
